import { render, staticRenderFns } from "./thumbs.vue?vue&type=template&id=28ee8a8a&scoped=true&"
import script from "./thumbs.vue?vue&type=script&lang=js&"
export * from "./thumbs.vue?vue&type=script&lang=js&"
import style0 from "./thumbs.vue?vue&type=style&index=0&id=28ee8a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee8a8a",
  null
  
)

export default component.exports